import { render, staticRenderFns } from "./PersonaBoard.vue?vue&type=template&id=70b0be11&"
import script from "./PersonaBoard.vue?vue&type=script&lang=js&"
export * from "./PersonaBoard.vue?vue&type=script&lang=js&"
import style0 from "./PersonaBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports